module.exports = __webpack_public_path__ + "img/haochu_img@2x.25a3d34b.png";